
     
     <div class="panel2">
       
        <div class="panel-body1"  
        [style.display]="(isEligibleforAuthentication==true && messageId!='undefined' && showSuccessMessage==false)? 'block' : 'none'" >
            <div class="upload-instructions">
            <div class="row" >
                <div class="col-md-2"><img [src]="uploadImageUrl" alt='Upload' class="img_upload"/></div>
                <div class="col-md-10 text-left" >
                    <h5 class="panelholdimg">{{"ReceiptAuthentication.BodyTitle" | translate}}</h5>
                    <hr>
                    <p>{{"ReceiptAuthentication.UploadInstruction1" | translate}}</p>
                    <p>{{"ReceiptAuthentication.UploadInstruction2" | translate}}</p>
                    <p>{{"ReceiptAuthentication.UploadInstruction3" | translate}}</p>
                </div>
            </div>
        </div>
            <div class="row">
                <div class="col-md-12">
                <h5 class="text-left mt-2 panelholdimg">{{"ReceiptAuthentication.Title" | translate}}</h5>
               <div class="receipt-authentication">
                <div class="file-select-zone" >
                    <ngx-file-drop 
                    [multiple]="false" dropZoneLabel="Drop files here"  (onFileDrop)="Dropped($event)" 
                    (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                          {{"ReceiptAuthentication.DragAndDrop" | translate}} 
                     <button id="btnUpload" type="button" class="dropdown-placeholder" (click)="HideErrorMessage()" (click)="openFileSelector()">{{"ReceiptAuthentication.UploadButtonText" | translate}}  </button>
                    </ng-template>
                    </ngx-file-drop>'
                </div>
            </div>
            </div>
            </div>
            <div *ngIf="showProgressBar" >
                
                    <mat-progress-bar
                    class="example-margin"
                    [color]="color"
                    [mode]="mode"
                    [value]="value"
                    [bufferValue]="bufferValue">
                    </mat-progress-bar>
            </div>
            <div class="" [style.display]="showError ? 'block' : 'none'">
                <p class="texterror">{{errorMessage | translate}}</p> 
            </div>
            
              <div class="upload-table">
                <table class="table">
                    
                    <tbody class="upload-name-style">
                        
                        <tr *ngIf="fileNameToDisplay">
                            <td></td>
                            <td  class="text-left">

                                <span id="tdFileName" class="btn btn-danger filefix">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="white" width="18" height="18" viewBox="0 0 18 18">
                                        <path d="M13 14c0 2.21-1.79 4-4 4s-4-1.79-4-4V3c0-1.66 1.34-3 3-3s3 1.34 3 3v9c0 1.1-.9 2-2 2s-2-.9-2-2V4h1v8c0 .55.45 1 1 1s1-.45 1-1V3c0-1.1-.9-2-2-2s-2 .9-2 2v11c0 1.66 1.34 3 3 3s3-1.34 3-3V4h1v10z"/>
                                    </svg>
                                {{ fileNameToDisplay }}</span></td>
                            <td style=" padding-top: 20px !important;">{{fileSize}}</td>
                            <td><a class="delete" (click)="DeleteFile()" title="Delete" data-toggle="tooltip">
                            <!-- <i class="material-icons icon-color">&#xE872;</i> -->
                            <img [src]="deleteIconPath" height="18" alt="delete">
                            
                        </a>
                            </td>
                        </tr> 
                    </tbody>
                </table>
            </div>
            <button  (click)="Authenticate()" type="button" id="largeReceiptDownload" class="btn btn-success">{{"ReceiptAuthentication.AuthenticateButtonText" | translate}} </button>
        </div>

        <div class="panel-body-error" [style.display]="(isEligibleforAuthentication==false && senderAddress!=null) ? 'block' : 'none'">
        
            <p class="texterror">{{"ReceiptAuthentication.NoUnitsMsgPageLoad" | translate}}</p> 
            
            <p class="textnote">{{"DownloadAuthenticatedReceipt.Note1" | translate}} <a href="https://www.rpost.com" >https://www.rpost.com </a>{{"DownloadAuthenticatedReceipt.Note2" | translate}}</p>
        </div>
        <div class="panel-body-error" [style.display]="(isEligibleforAuthentication==false && senderAddress==null) ? 'block' : 'none'">
        
            <p class="texterror">{{"ReceiptAuthentication.SenderDetailsNotFoundMsg" | translate}}</p> 
            
            
            <p>
                {{"DownloadAuthenticatedReceipt.Note1" | translate}}
                
                <a href="https://www.rpost.com"> https://www.rpost.com </a>
                {{"DownloadAuthenticatedReceipt.Note2" | translate}}
            </p>
        </div>
        <div class="panel-body-error" [style.display]="(messageId==undefined) ? 'block' : 'none'">
    
            <p class="texterror">{{"ReceiptAuthentication.InvalidMessageId" | translate}}</p> 
            
            <p class="textnote">{{"DownloadAuthenticatedReceipt.Note1" | translate}} <a href="https://www.rpost.com" > https://www.rpost.com </a>{{"DownloadAuthenticatedReceipt.Note2" | translate}}</p>
        </div>
        
    </div>
  


  
  

  
